import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    REPORT_USAGE,
} from 'src/constants/appConstants';
import {
    getConfigurations,
} from 'src/common/redux/actions';
import { setPageLoader } from '../redux/action/actionCreators';

export function useReportUsageInit({ dispatch, getOrderSummaryData, myCaseResourceType}) {
    useEffectWithErrorLogging(() => {
        dispatch(
            getConfigurations(
                { resourceType: 'visibility', module: REPORT_USAGE },
                REPORT_USAGE
            )
        );
        dispatch(setPageLoader(true)); // Start loading
        dispatch(getOrderSummaryData());
    }, [myCaseResourceType]);
}
